const state = {
  fields: { label: 'name', value: 'id', children: 'children' },

  macros: false,

  macros_options: [],

  // Macros API
  macros_api: '/api/v1/system/macros',

  macros_setting_api: '/api/v1/settings/macros',

  macros_categories_api: '/api/v1/settings/macros/categories/',

  // Macros items
  macro_items: [],
  // Macros categories
  macros_categories: [],

  // Macros items pagination
  macros_pagination: {'current_page': 0, 'total': 0, 'per_page': 0},

  // Macros items search
  search_macros: '',

};

// getters
const getters = {
  // Get field names
  getFields: (state) => {
    // Return fields
    return state.fields;
  },

  // Get category
  getMacrosOptions: (state) => {
    // Return categories
    return state.macros_options;
  },

  // Get Macros Categories
  getMacrosCategories: (state) => {
    // Return categories
    return state.macros_categories;
  },

  // Get Macros Items
  getMacrosItems: (state) => {
    // Return categories
    return state.macro_items;
  },

  // Get Macros Items pagination
  getMacrosPagination: (state) => {
    return state.macros_pagination;
  },

  // Get Macros Items search
  getSearchMacros: (state) => {
    return state.search_macros;
  },

};

// mutations
const mutations = {

  // Set macros options
  setMacrosOptions (state, macros_options) {
    state.macros_options = macros_options;
  },

  // Set macros options
  setMacrosCategories (state, macros_categories) {
    state.macros_categories = macros_categories;
  },

  // Set macros options
  setMacrosItems (state, macros_items) {
    state.macro_items = macros_items;
  },

  // Set macros items pagination
  setMacrosPagination (state, macros_pagination) {
    state.macros_pagination = macros_pagination;
  },

  // Set macros items search
  setSearchMacros (state, search_macros) {
    state.search_macros = search_macros;
  },

};

// actions
const actions = {

  // Update Macro
  async updateMacrosData({ dispatch, state }){

    // Check if don't have macros
    if(!state.macros_options || state.macros_options.length <= 0){

      dispatch('fetchMacros');

    }

  },

  async fetchMacrosCategories({state, dispatch, commit}){


    // Start waiting
    dispatch('wait/start', 'macros_categories', { root: true });

    // Get integrations
    await axios.get(state.macros_categories_api)

        .then((response) => {

          // Response data
          // Set categories
          commit('setMacrosCategories', response.data);
          dispatch('wait/end', 'macros_categories', { root: true });

        })
        .catch((error) => {

          // Show error
          Vue.toasted.error(Vue.i18n.translate('simple.error_info'));
          // Log to console
          console.log(error);

          // Stop waiting
          dispatch('wait/end', 'macros_categories', { root: true });

        });
  },


  async fetchMacros({ dispatch, commit}){

    // Get categories
    await axios.get(state.macros_api)
        .then((response) => {

          // Set categories
          commit('setMacrosOptions', response.data.flat());

          // Log to console
          console.log('Macros Data: ', response.data);

        })

        .catch((error) => {
          // Show error
          Vue.toasted.error(Vue.i18n.translate('simple.error_info'));

          // Log to console
          console.log(error);

        });
  },

  updateSearchMacros({commit}, search) {
    commit('setSearchMacros', search);
  },

  async fetchMacrosItems({state, dispatch, commit}, { page = 1, search = '' } = {}) {

    // Start waiting
    dispatch('wait/start', 'macros', { root: true });

    let api_params = '';
    if (search) {
      api_params = `&search=${search}`;
    }

    // Send request
    await axios.get(`${state.macros_setting_api}?page=${page}${api_params}`)

        .then((response) => {

            let items = response.data.data;

            items.forEach(buckets => {

                // console.log(buckets);
                // console.log(state.macros_categories);

                let macros = state.macros_categories.find(messages => messages.id == buckets['macros_category_id']);

                // parse and fill user, falling back gracefully when the
                // macro's category no longer exists (e.g. category deleted)
                buckets['description'] = macros ? macros.description : '';
                buckets['macros_category'] = macros ? macros.name : '';

            });
          // Set items
          commit('setMacrosItems', items);

          // Set pagination
          commit('setMacrosPagination', {
              current_page: response.data.current_page,
              total: response.data.total,
              per_page: response.data.per_page,
          });

          console.log('macro items', items);

          // Stop waiting
          dispatch('wait/end', 'macros', { root: true });

        })

        .catch((error) => {
          // Show error
           Vue.toasted.error(Vue.i18n.translate('simple.error_info'));
          // Log to console
          //console.log(error);


          // Stop waiting
          dispatch('wait/end', 'macros', { root: true });

        });

  },



};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};